module.exports = __webpack_public_path__ + "static/media/node.70637588.png";